export * from "./StickerTokenIcon";
